import React from "react";

export const LabelsContext = React.createContext([{}, () => {}]);
export const ThemeContext = React.createContext([{}, () => {}]);
export const UserContext = React.createContext([{}, () => {}]);
export const SocketContext = React.createContext([{}, () => {}]);
